import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconCreateTicketProps extends SVGProps<any> {}
export class SVGIconCreateTicket extends Component<SVGIconCreateTicketProps> {
  render() {
    const { width = 150, height = 150, ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-create-banner"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 75 75`}
        {...rest}
      >
        <g clip-path="url(#clip0_1767_36)">
          <path
            d="M70.5508 39.1258L43.2789 12.032C40.6477 9.42266 36.8852 8.14766 33.2133 8.62578L15.0789 10.6602L5.33516 0.916406C4.11328 -0.305469 2.13828 -0.305469 0.916406 0.916406C-0.305469 2.13828 -0.305469 4.11328 0.916406 5.33516L10.6602 15.0789L8.48516 34.1039C8.20078 37.6727 9.49453 41.1602 12.0352 43.6727L39.2633 70.6883C42.107 73.5195 45.882 75.0758 49.8883 75.0758H49.9508C53.982 75.0602 57.7633 73.4727 60.6008 70.6039L70.632 60.4727C76.4758 54.5664 76.4414 44.9883 70.5539 39.1227L70.5508 39.1258ZM66.1883 56.082L56.157 66.2133C54.4977 67.8914 52.2852 68.8195 49.9258 68.8289H49.8914C47.5445 68.8289 45.3352 67.9164 43.6664 66.257L16.4352 39.2352C15.2039 38.0164 14.5789 36.3289 14.7039 34.707L16.3039 20.7258L22.107 26.5289C21.9695 27.0414 21.8758 27.5727 21.8758 28.1289C21.8758 31.582 24.6727 34.3789 28.1258 34.3789C31.5789 34.3789 34.3758 31.582 34.3758 28.1289C34.3758 24.6758 31.5789 21.8789 28.1258 21.8789C27.5695 21.8789 27.0414 21.9758 26.5258 22.1102L20.732 16.3164L33.9383 14.8352L34.0039 14.8258C35.7789 14.5914 37.6008 15.207 38.8758 16.4664L66.1445 43.5539C69.5977 46.9977 69.6164 52.6133 66.1883 56.082ZM53.7695 39.9852C52.5477 38.7633 50.5727 38.7633 49.3508 39.9852L39.9758 49.3602C38.7539 50.582 38.7539 52.557 39.9758 53.7789L47.7883 61.5914C48.3977 62.2008 49.1977 62.507 49.9977 62.507C50.7977 62.507 51.5977 62.2008 52.207 61.5914L61.582 52.2164C62.8039 50.9945 62.8039 49.0195 61.582 47.7977L53.7695 39.9852ZM49.9977 54.9633L46.6039 51.5695L51.5602 46.6133L54.9539 50.007L49.9977 54.9633Z"
            fill="#513389"
          />
        </g>
        <defs>
          <clipPath id="clip0_1767_36">
            <rect width="75" height="75" fill="white" />
          </clipPath>
        </defs>
      </SVG>
    );
  }
}
